module.exports = __webpack_public_path__ + "media/dòot nom nòi.39c41c76.mp3";